const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import { mainStore } from '../_store/main';
import OnScreenItem from './OnScreenItem';

import gsap, { Expo } from 'gsap/gsap-core';
import { SimpleLayoutMode } from '../_types/common';

@Component
export default class ServiceIegao extends Vue {
  @Ref('box')
  public box!: HTMLDivElement;

  @Ref('spacer')
  public spacer!: HTMLDivElement;

  public scrollHeight: number = 0;
  public scrollRatio: number = 0;
  public isScrolledAway: boolean = false;
  public offsetTop: number = 0;
  public offsetHeight: number = 0;
  public featuresOffset: number = 0;
  public lockStart: number = 0;
  public lockEnd: number = 0;

  public onResize() {
    gsap.killTweensOf(this.box);
    const el = this.$el as HTMLElement;

    if(el && this.box && this.spacer) {
      this.offsetTop = g.getOffsetTop(this.spacer);
      this.offsetHeight = el.offsetHeight;
      this.lockStart = this.offsetTop;
      this.lockEnd = this.offsetTop + this.offsetHeight - this.spacer.offsetHeight;
    }
  }

  public scroll(to) {
    let offset = 0;
    if(to > this.lockStart && to < this.lockEnd) {
      offset = (to - this.lockStart);
    } else if(to <= this.lockStart) {
      offset = 0;
    } else if(to >= this.lockEnd) {
      offset = (this.lockEnd - this.lockStart);
    }
    gsap.killTweensOf(this.box);
    gsap.to(this.box, 0.8, { ease: Expo.easeOut, y: offset, z: 0 });
  }

  // public onScroll() {
  //   let offset = 0;
  //   if(mainStore.scrollTop > this.lockStart && mainStore.scrollTop < this.lockEnd) {
  //     offset = (mainStore.scrollTop - this.lockStart);
  //   } else if(mainStore.scrollTop <= this.lockStart) {
  //     offset = 0;
  //   } else if(mainStore.scrollTop >= this.lockEnd) {
  //     offset = (this.lockEnd - this.lockStart);
  //   }

  //   gsap.killTweensOf(this.box);
  //   this.box.style.transform = `translateY(${offset}px)`;
  //   // gsap.to(this.box, 0.8, { ease: Expo.easeOut, y: offset });
  // }
}